import { usePwaInstall } from "@/hooks/use-pwa-install";
import { X } from "lucide-react";

export function PwaInstallBanner() {
  const { canInstall, install, dismiss } = usePwaInstall();

  if (!canInstall) return null;

  return (
    <div className="fixed bottom-24 md:bottom-4 left-1/2 z-40 flex max-w-[calc(100vw-1.5rem)] -translate-x-1/2 items-center gap-3 rounded-lg border border-cyan-500/30 bg-[#05080f]/95 px-4 py-3 shadow-lg backdrop-blur-sm">
      <span className="text-sm text-cyan-100">Install KPKL Radio for quick access</span>
      <button
        onClick={install}
        className="rounded-md bg-cyan-500 px-3 py-1 text-sm font-semibold text-black hover:bg-cyan-400"
      >
        Install
      </button>
      <button
        onClick={dismiss}
        aria-label="Dismiss"
        className="text-cyan-500/70 hover:text-cyan-400"
      >
        <X size={16} />
      </button>
    </div>
  );
}
